import { Component, computed, effect, input, output, Type, viewChild, ViewContainerRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { AssistantType } from '@vendasta/ai-assistants';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import {
  DEFAULT_SHOPIFY_MCP_GOAL_ID,
  DEFAULT_TRANSFER_CALL_GOAL_ID,
  DEFAULT_VOICE_LEAD_CAPTURE_GOAL_ID,
} from '../../../core/ai-assistant.constants';
import { AiCapabilityForm, AiToolForm, CustomCapabilityConfigurationForm } from '../../../core/forms';
import { AiCapabilityFormComponent } from '../ai-capability-form/ai-capability-form.component';
import {
  BookMeNowCapabilityFormComponent,
  DEFAULT_MEETING_BOOKING_GOAL_ID,
} from '../ai-capability-form/custom-forms/book-me-now-capability-form/book-me-now-capability-form.component';
import { McpIntegrationCapabilityFormComponent } from '../ai-capability-form/custom-forms/mcp-integration-capability-form/mcp-integration-capability-form.component';
import {
  DEFAULT_SALES_COACH_GOAL_ID,
  SalesCoachCapabilityFormComponent,
} from '../ai-capability-form/custom-forms/sales-coach-capability-form/sales-coach-capability-form.component';
import { TransferCallCapabilityFormComponent } from '../ai-capability-form/custom-forms/transfer-call-capability-form/transfer-call-capability-form.component';

// Custom forms used for specific capabilities.
// If `null` is provided, then no form will be shown for that capability.
export const AiCapabilityCustomForms: { [goalId: string]: Type<CustomCapabilityConfigurationForm> | undefined | null } =
  {
    [DEFAULT_MEETING_BOOKING_GOAL_ID]: BookMeNowCapabilityFormComponent,
    [DEFAULT_SALES_COACH_GOAL_ID]: SalesCoachCapabilityFormComponent,
    [DEFAULT_VOICE_LEAD_CAPTURE_GOAL_ID]: null,
    [DEFAULT_SHOPIFY_MCP_GOAL_ID]: McpIntegrationCapabilityFormComponent,
    [DEFAULT_TRANSFER_CALL_GOAL_ID]: TransferCallCapabilityFormComponent,
  };

@Component({
  selector: 'ai-capability-form-loader',
  imports: [GalaxyFormFieldModule, TranslateModule, MatInputModule, ReactiveFormsModule, AiCapabilityFormComponent],
  templateUrl: './ai-capability-form-loader.component.html',
})
export class AiCapabilityFormLoaderComponent {
  customForm = computed(() => AiCapabilityCustomForms?.[this.capabilityForm().controls.goalId?.value || '']);
  capabilityForm = input.required<AiCapabilityForm>();
  onlySpecialCaseCapabilities = input<boolean>(false);
  assistantType = input<AssistantType>();

  // This will only emit for the base form, not the custom forms.
  readonly toolFormDisplay = output<{ parentCapabilityForm?: AiCapabilityForm; form: AiToolForm } | undefined>();

  formContainer = viewChild('formContainer', { read: ViewContainerRef });

  constructor() {
    effect(() => {
      const customForm = this.customForm();
      if (!!customForm && this.formContainer()) {
        const componentRef = this.formContainer()?.createComponent(customForm);
        if (componentRef) {
          componentRef.setInput('configurationForm', this.capabilityForm().controls.configuration);
          componentRef.setInput('goalId', this.capabilityForm().controls.goalId.value);
        }
      }
    });
  }
}
